var Theme = {};

const BREAKPOINT_LARGEDESKTOP   = 1800;
const BREAKPOINT_MEDIUMDESKTOP  = 1500;
const BREAKPOINT_DESKTOP        = 1360;
const BREAKPOINT_LAPTOP         = 1280;
const BREAKPOINT_TABLETHOR      = 1024;
const BREAKPOINT_TABLET         = 768;
const BREAKPOINT_PHABLET        = 576;
const BREAKPOINT_MOBILE         = 325;

(function ($, Drupal, drupalSettings) {
  'use strict';

  Drupal.Theme = {};

  /**
   * Constructeur
   */
  Theme.Common = function () {
    // Éléments
    this.elements = {
      htmlBody: $('html, body'),
      body: $('body'),
      page: $('#page'),
    };

    this.elements.externalLinks = this.elements.page.find('a[href^="http"]');
    this.elements.openInNewWindowLinks = this.elements.page.find('a[href$=".pdf"]');

    // Variables
    this.menuScrollOffset = 110;
    this.langcode = drupalSettings.path.currentLanguage || 'fr';
    this.darkSideTextBack = $('#block-menu-shortcuts .level0').data('dark-side-back');

    return this;
  };

  /**
   * Méthodes
   */
  Theme.Common.prototype = {
    load: function (className, options) {
      if (Theme[className] !== undefined) {
        return new Theme[className](this, options);
      } else {
        console.error('Class "Theme.' + className + '" not found.');
      }
    },
    autoload: function (options) {
      var self = this;

      if (options !== undefined) {
        $.each(options, function (className, condition) {
          if (self.elements.body.is(condition)) {
            return self.load(className).init();
          }
        });

      } else {
        console.error('Options is undefined.');
      }
    },

    /**
     * Init common
     */
    init: function () {
      //this.cookieTarteAuCitronHandler();
      this.externalLinksHandler();
      this.openInNewWindowHandler();
      this.anchorLinksHandler();
    },

    /**
     * Gestionnaire des liens externes
     */
    externalLinksHandler: function () {
      if (this.elements.externalLinks.length) {
        this.elements.externalLinks.each(function (i, link) {
          link = $(link);

          if (link.attr('href').indexOf(window.location.host) === -1) {
            link.attr('target', '_blank');
          }
        });
      }
    },

    /**
     * Gestionnaire pour l'ouverture de lien dans un nouvel onglet
     */
    openInNewWindowHandler: function () {
      if (this.elements.openInNewWindowLinks.length) {
        this.elements.openInNewWindowLinks.on('click', function (event) {
          event.preventDefault();
          window.open($(event.currentTarget).attr('href'));
        });
      }
    },

    /**
     * Gestionnaire des ancres
     */
    anchorLinksHandler: function () {
      var self = this;

      self.elements.page.on('click', 'a[href*="#"]:not([href="#"])', function (event) {
        if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {
          var target = $(this.hash);
          target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

          if (target.length) {
            event.preventDefault();

            self.scrollTop(target.offset().top);
          }
        }
      });
    },

    /**
     * Scroll top
     *
     * @param offset
     * @param speed
     */
    scrollTop: function (offset, speed) {
      speed = speed || 500;

      this.elements.htmlBody.animate({
        scrollTop: (offset - this.menuScrollOffset)
      }, speed);

      return this;
    },

  };

  /**
   * Load Themes
   * @type {{attach: attach, detach: detach}}
   */
  Drupal.behaviors.drupTheme = {
    attach: function (context) {
      if (context.body !== undefined) {
        Drupal.Theme = new Theme.Common();
        Drupal.Theme.init();
        Drupal.Theme.load('all').init();

        // Drupal.Theme.autoload({
        //     front: '.is-front'
        // });
      }
      else if ($(context).hasClass('view-display-list-blog')) {
          Drupal.Theme = new Theme.Common();
          Drupal.Theme.init();
          Drupal.Theme.load('all').initViewsFiltered('.view-display-list-blog');
      }
      else if ($(context).hasClass('view-display-list-productions')) {
          Drupal.Theme = new Theme.Common();
          Drupal.Theme.init();
          Drupal.Theme.load('all').initViewsFiltered('.view-display-list-productions');
      }
      else if ($(context).hasClass('view-display-list-news')) {
          Drupal.Theme = new Theme.Common();
          Drupal.Theme.init();
          Drupal.Theme.load('all').initViewsFiltered('.view-display-list-news');
      }

      // reload après appels ajax
      else {
        Drupal.Theme = new Theme.Common();
        Drupal.Theme.init();
        Drupal.Theme.load('all').listJobOffers();
        Drupal.Theme.load('all').initLazyLoad();
      }

    }
  };
  Drupal.behaviors.viewsScrollOff = {
    attach: function () {
      /* Views Ajax Content Load Autoscroll Feature Disabled */
      Drupal.AjaxCommands.prototype.viewsScrollTop = function (ajax, response) {

        // vue list job : scroll vers les résultats à chaque recherche
        if ($('.view-display-list-jobs').length > 0) {
          var scrollTarget = response.selector;
          if ($(scrollTarget).find('.view-content') && $(window).outerWidth() >= BREAKPOINT_TABLETHOR) {
            var elemToScroll = $(scrollTarget).find('.view-content').first();

            if ($(window).scrollTop() > 420) {
              $('html, body').stop().animate({scrollTop: elemToScroll.offset().top - 300}, 500);
            }
          }
        }
        else {
          var offset = $(response.selector).offset();

          var scrollTarget = response.selector;
          while ($(scrollTarget).scrollTop() === 0 && $(scrollTarget).parent()) {
            scrollTarget = $(scrollTarget).parent();
          }

          if (offset.top - 10 < $(scrollTarget).scrollTop()) {
            $(scrollTarget).animate({ scrollTop: offset.top - 10 }, 500);
          }
        }
      };
    }
  };

}(jQuery, Drupal, drupalSettings));

